/**
 * Production stand-in for `@contentful/live-preview` and `@contentful/live-preview/react`.
 *
 * `onCreateWebpackConfig` swaps the real package for this file whenever CONTENTFUL_PREVIEW is
 * off, so the SDK never ships in a production (or ordinary develop) bundle. The provider is a
 * pass-through and the hooks are no-ops, matching the "preview code is gated on the frame"
 * behaviour when the library itself is absent.
 */

const noop = () => undefined

const ContentfulLivePreviewProvider = ({ children }) => children

const useContentfulLiveUpdates = data => data

const getInspectorProps = () => ({})

const useContentfulInspectorMode = () => getInspectorProps

const ContentfulLivePreview = {
  init: noop,
  subscribe: () => noop,
  get initialized() {
    return false
  },
}

module.exports = {
  ContentfulLivePreviewProvider,
  useContentfulLiveUpdates,
  useContentfulInspectorMode,
  ContentfulLivePreview,
  LIVE_PREVIEW_EDITOR_SOURCE: 'live-preview-editor',
  LivePreviewPostMessageMethods: {
    ENTRY_SAVED: 'ENTRY_SAVED',
  },
}
